module.exports = __webpack_public_path__ + "static/parcel-size-calc-6f5efa9a5fdaea3506dedee968e588ce.png";